import { render, staticRenderFns } from "./IosDownMobile.vue?vue&type=template&id=638b9d85&scoped=true&"
import script from "./IosDownMobile.vue?vue&type=script&lang=js&"
export * from "./IosDownMobile.vue?vue&type=script&lang=js&"
import style0 from "./IosDownMobile.vue?vue&type=style&index=0&id=638b9d85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638b9d85",
  null
  
)

export default component.exports